import { EnumBase } from 'hay-core-react';
class TemplateTestestatusEnum extends EnumBase {
  constructor() {
    super(
      [
        'main.monitoramentotemplate.testestatus.haymonitoramento',
        'main.monitoramentotemplate.testestatus.desativado',
      ],
      'main.monitoramentotemplate.testestatus.desativado'
    );
  }
}

export default new TemplateTestestatusEnum();
